const upperAllFirst = (text = "")=>text.split(" ").map((item)=>item.length >= 1 ? item[0].toUpperCase() + item.slice(1) : item).join(" ");
const upperFirst = (text = "")=>text?.length >= 1 ? text[0].toUpperCase() + text.slice(1) : text;
const getLabel = (value, options)=>options?.find((classification)=>classification.value === value)?.label;
const isStringNumber = (value)=>[
        "string",
        "number"
    ].includes(typeof value) && value !== "" && !Number.isNaN(Number(value));
const deburrAndLowercase = (text = "")=>text.normalize("NFD").replace(RegExp("\\p{Diacritic}", "gu"), "").toLocaleLowerCase();

export { deburrAndLowercase, getLabel, isStringNumber, upperAllFirst, upperFirst };
//# sourceMappingURL=string.js.map
